import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrl: './otp-input.component.scss'
})
export class OtpInputComponent {
  @Input({ required: true }) contorl: FormControl;

  isInvalid() {
    return false;
  }

  one: string = '';
  two: string = '';
  three: string = '';
  four: string = '';

  onInput(event: Event, nextInput: HTMLInputElement | null) {
    const input = event.target as HTMLInputElement;
    if (input.value.length === 1 && nextInput) {
      nextInput.focus();
    }

    this.updateFormControlValue();
  }

  onBackspace(event: KeyboardEvent, previousInput: HTMLInputElement | null) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace') {
      if (input.value === '') {
        previousInput?.focus();
      }
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';

    const digits = pastedData.replace(/\D/g, '');

    this.one = digits[0] || '';
    this.two = digits[1] || '';
    this.three = digits[2] || '';
    this.four = digits[3] || '';

    this.updateFormControlValue();
  }

  private updateFormControlValue() {
    this.contorl.setValue(this.one + this.two + this.three + this.four);
  }

}
